import { Endereco } from './../../../core/models/pessoa.model';
import {
  PessoaBaseModel,
  PessoaModel,
} from '../../../core/models/pessoa.model';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { EnumDataset } from '../../../core/enums/enum-dataset';
import { GestaoPessoaService } from '../service/pessoa.service';
import { ListarPessoaModel } from '../models/listar-pessoa.model';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputMaskModule } from 'primeng/inputmask';
import { DialogModule } from 'primeng/dialog';
import { EnumTipoPessoa } from '../../../core/enums/enum-tipo-pessoa';
import { getEnumValues } from '../../../core/tools/helper.tools';
import { DropdownModule } from 'primeng/dropdown';
import { TitleComponent } from '../../../core/componentes/Title/title.component';
import { VoltarComponent } from '../../../core/componentes/voltar/voltar.component';
import { PlanoModel } from '../../gestaoPlano/models/plano.model';
import { PlanoService } from '../../gestaoPlano/service/plano.service';

@Component({
  selector: 'app-pessoa',
  templateUrl: './pessoa.gestao.html',
  styleUrl: './pessoa.gestao.scss',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    InputTextModule,
    FloatLabelModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    InputMaskModule,
    DialogModule,
    DropdownModule,
    TitleComponent,
    VoltarComponent,
  ],
})
export class PessoaGestao implements OnInit {
  public translate = inject(TranslateService);

  constructor(private formBuilder: FormBuilder, private router: Router) {}

  //#region Service
  pessoaService = inject(GestaoPessoaService);
  planoService = inject(PlanoService);
  route = inject(ActivatedRoute);
  //#endregion

  //#region Inicialização
  token: string = sessionStorage.getItem(EnumDataset.dataSetLogin) || '';
  pessoaId: number = 0;
  filtroForm: FormGroup = this.initFormulario();
  pessoas: ListarPessoaModel[] = [];
  showAssociacaoDialog: boolean = false;
  showPlanoDialog: boolean = false;
  tipoPessoaConst = getEnumValues(EnumTipoPessoa);
  pessoa: PessoaModel = {
    endereco: {},
  } as PessoaModel;

  planosAssociados: PlanoModel[] = [];
  planos: PlanoModel[] = [];
  planosSelecionados: PlanoModel[] = [];

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.pessoaId = +params.get('id')!; // Obtém o valor do parâmetro 'id'
    });

    this.buscarHierarquiaPessoa();
    this.buscarPessoa();
    this.buscarPlanosAssociados();
  }
  initFormulario() {
    this.filtroForm = this.formBuilder.group({
      nome: [''],
      telefone: [''],
    });

    return this.filtroForm;
  }
  /**
   * Busca uma pessoa por ID.
   * @returns Uma Promise que resolve com o objeto {@link ListarPessoaModel} da pessoa encontrada.
   */
  buscarHierarquiaPessoa() {
    this.pessoaService.buscarHierarquiaPessoa(this.pessoaId).then((res) => {
      this.pessoas = res;
    });
  }

  buscarPessoa() {
    this.pessoaService.buscarPessoaPorId(this.pessoaId).then((res) => {
      this.pessoa = res as PessoaModel;
    });
  }

  //#endregion

  //#region Actions

  showAssociarPessoaDialog() {
    this.showAssociacaoDialog = true;
  }

  showAssociarPlanoDialog() {
    this.showPlanoDialog = true;
    this.buscarPlanos();
  }

  salvarAssociarPlano() {
    this.showPlanoDialog = false;

    this.pessoaService
      .salvarAssociarPlano(this.pessoaId, this.planosSelecionados.map((p) => p.id))
      .then((res) => {});
  }

  desvincularPlano(planoId: number) {
    this.pessoaService.desvincularPlano(this.pessoaId, planoId).then((res) => {});
  }

  buscarPlanosAssociados() {
    this.pessoaService.buscarPlanosAssociados(this.pessoaId).then((res) => {
      this.planosAssociados = res;
    });
  }

  buscarPlanos() {
    this.planoService.buscarPlanos({}).then((res) => {
      this.planos = res;
      this.planos = this.diferencaPorId(this.planos, this.planosAssociados);
    });
  }


  diferencaPorId(listaBase: any[], listaComparacao: any[]): any[] {
    const itensDiferentes = listaBase.filter(
      (itemBase) => !listaComparacao.some((itemComparacao) => itemComparacao.id === itemBase.id)
    );
    return itensDiferentes;
  }

  //#endregion
}
